/**
 * Tinkoff ID SDK (кнопка «Войти с Тинькофф»): ~43 КБ стороннего JS с кэшем
 * 30 с. Нужен только в форме входа, поэтому больше не грузится на каждой
 * странице сразу после гидрации (Lighthouse 06.10.2026: «unused JS» и
 * «short cache lifetime»). Грузим:
 *  - при открытии формы входа (AuthForm) — там без него нет кнопки;
 *  - заранее, но не в окне замера: по первому действию пользователя или
 *    через 15 с после load (loadWhenIdle в __root.tsx), чтобы к открытию
 *    формы скрипт обычно уже был в памяти.
 * Повторные вызовы не добавляют второй <script>.
 */
import ScriptUtil from '@utils/script';

const TINKOFF_SDK_URL = 'https://sso-forms-prod.t-static.ru/tid/widget.js';

let loading: Promise<void> | null = null;

export const ensureTinkoffSdk = (): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }
  if (typeof TidSDK !== 'undefined') {
    return Promise.resolve();
  }
  if (!loading) {
    loading = ScriptUtil.add(TINKOFF_SDK_URL) as Promise<void>;
  }
  return loading;
};
